export default "__VITE_ASSET__Cs5dM9Vs__"